import { useQuery, keepPreviousData as previousPlaceholder } from '@tanstack/react-query';

import { useApi } from '../contexts/ApiContext';

export function prefetchFormat(queryClient, api, slug) {
    return queryClient.prefetchQuery({
        queryKey: ['format', slug],
        queryFn: ({ queryKey: [, slugParam], signal }) =>
            api.taxonomies.formats(
                {
                    uri: slugParam,
                },
                null,
                null,
                { signal },
            ),
    });
}

export function fetchFormat(queryClient, api, slug) {
    return queryClient.fetchQuery({
        queryKey: ['format', slug],
        queryFn: ({ queryKey: [, slugParam], signal }) =>
            api.taxonomies.formats(
                {
                    uri: slugParam,
                },
                null,
                null,
                { signal },
            ),
    });
}

export default function useFormat(slug, opts = null) {
    const api = useApi();
    const { keepPreviousData = true } = opts || {};
    const {
        data: format = null,
        isFetched = false,
        ...queryResult
    } = useQuery({
        queryKey: ['format', slug],
        queryFn: ({ queryKey: [, slugParam], signal }) =>
            api.taxonomies.formats(
                {
                    uri: slugParam,
                },
                null,
                null,
                { signal },
            ),
        suspense: false,
        placeholderData: keepPreviousData ? previousPlaceholder : null,
        ...opts,
    });

    return {
        format,
        notFound: format === null && isFetched,
        isFetched,
        ...queryResult,
    };
}
